import { Platform } from 'react-native'
import { PB_SERVER_ADDR, pb } from './pocketbase'

export async function uploadOrgLogo(
    orgId: string,
    imageUri: string,
    mimeType: string
): Promise<string> {
    const formData = new FormData()

    if (Platform.OS === 'web') {
        const response = await fetch(imageUri)
        const blob = await response.blob()
        const extension = mimeType.split('/')[1] || 'png'
        formData.append('logo', blob, `logo.${extension}`)
    } else {
        const extension = mimeType.split('/')[1] || 'png'
        formData.append('logo', {
            uri: imageUri,
            type: mimeType,
            name: `logo.${extension}`,
        } as unknown as Blob)
    }

    const result = await pb.collection('orgs').update(orgId, formData)
    return (result as unknown as { logo: string }).logo
}

export async function deleteOrgLogo(orgId: string): Promise<void> {
    await pb.collection('orgs').update(orgId, { logo: null })
}

export function getOrgLogoUrl(
    orgId: string,
    logoFilename: string | null | undefined,
    thumbSize?: '100x100' | '200x200'
): string | null {
    if (!logoFilename) return null

    const baseUrl = `${PB_SERVER_ADDR}/api/files/orgs/${orgId}/${logoFilename}`

    if (thumbSize) {
        return `${baseUrl}?thumb=${thumbSize}`
    }

    return baseUrl
}
